import MenuComponent from '@/components/MenuComponent'
import BlocAuthenticated from '@/components/BlocAuthenticated'

export default {
  components: {
    MenuComponent,
    BlocAuthenticated
  },
  data () {
    return {
      roles: [],
      loading: false
    }
  },
  methods: {
    async createRoleAdministrateur () {
      this.loading = true
      this.$store.dispatch('xarm/createRoleAdministrateur', this.$store.state.user.user.login).then(
        () => {
          this.loading = false
          this.$router.push({ name: 'administration/role/list' })
        },
        error => {
          this.loading = false
          this.errorMessage = error.response
        }
      )
    },
    async createRoleAdministrateurBo () {
      this.loading = true
      this.$store.dispatch('xarm/createRoleAdministrateurBo', this.$store.state.user.user.login).then(
        () => {
          this.loading = false
          this.$router.push({ name: 'administration/role/list' })
        },
        error => {
          this.loading = false
          this.errorMessage = error.response
        }
      )
    },
    async createRoleGestionnaire () {
      this.loading = true
      this.$store.dispatch('xarm/createRoleGestionnaire', this.$store.state.user.user.login).then(
        () => {
          this.loading = false
          this.$router.push({ name: 'administration/role/list' })
        },
        error => {
          this.loading = false
          this.errorMessage = error.response
        }
      )
    },
    async createRolePorteur () {
      this.loading = true
      this.$store.dispatch('xarm/createRolePorteur', this.$store.state.user.user.login).then(
        () => {
          this.loading = false
          this.$router.push({ name: 'administration/role/list' })
        },
        error => {
          this.loading = false
          this.errorMessage = error.response
        }
      )
    },
    async createRoleDemoGestionnaire () {
      this.loading = true
      this.$store.dispatch('xarm/createRoleDemoGestionnaire', this.$store.state.user.user.login).then(
        () => {
          this.loading = false
          this.$router.push({ name: 'administration/role/list' })
        },
        error => {
          this.loading = false
          this.errorMessage = error.response
        }
      )
    },
    async createRoleDemoPorteur () {
      this.loading = true
      this.$store.dispatch('xarm/createRoleDemoPorteur', this.$store.state.user.user.login).then(
        () => {
          this.loading = false
          this.$router.push({ name: 'administration/role/list' })
        },
        error => {
          this.loading = false
          this.errorMessage = error.response
        }
      )
    },
    async createXarmRoleLogsAdmin () {
      this.loading = true
      this.$store.dispatch('xarm/createXarmRoleLogsAdmin', this.$store.state.user.user.login).then(
        () => {
          this.loading = false
          this.$router.push({ name: 'administration/role/list' })
        },
        error => {
          this.loading = false
          this.errorMessage = error.response
        }
      )
    },
    async addPermAddtPorteurData () {
      this.loading = true
      this.$store.dispatch('xarm/addPermAddtPorteurData', this.$store.state.user.user.login).then(
        () => {
          this.loading = false
          this.$router.push({ name: 'administration/role/list' })
        },
        error => {
          this.loading = false
          this.errorMessage = error.response
        }
      )
    },
    async addPermissDDDSecure () {
      this.loading = true
      this.$store.dispatch('xarm/addPermissDDDSecure', this.$store.state.user.user.login).then(
        () => {
          this.loading = false
          this.$router.push({ name: 'administration/role/list' })
        },
        error => {
          this.loading = false
          this.errorMessage = error.response
        }
      )
    },
    async addPermissEmailMaj () {
      this.loading = true
      this.$store.dispatch('xarm/addPermissEmailMaj', this.$store.state.user.user.login).then(
        () => {
          this.loading = false
          this.$router.push({ name: 'administration/role/list' })
        },
        error => {
          this.loading = false
          this.errorMessage = error.response
        }
      )
    },
    async addPermAddtPorteurDataAdmin () {
      this.loading = true
      this.$store.dispatch('xarm/addPermAddtPorteurDataAdmin', this.$store.state.user.user.login).then(
        () => {
          this.loading = false
          this.$router.push({ name: 'administration/role/list' })
        },
        error => {
          this.loading = false
          this.errorMessage = error.response
        }
      )
    }
  },
  beforeCreate () {
    this.$store.state.filArianePage = 'Création d\'un role'
    this.$store.state.filArianeMiddlePage = 'Liste des roles'
    this.$store.state.filArianeMiddleRouterLink = 'administration/role/list'
  }
}
